// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import RoutesComponent from "./routes";
import "./App.css";

const App = () => {
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Router>
        <RoutesComponent />
      </Router>
    </SnackbarProvider>
  );
};

export default App;
